import "./js/main";
import "./lib/easing/easing";
import "./lib/owlcarousel/owl.carousel";
import "./lib/tempusdominus/js/tempusdominus-bootstrap-4";
import "./lib/wow/wow";